import { DealDataMappedType } from '@/components/ScrollableDealModule/types'
import { GA4Product } from './types'

type BuildGA4ObjectForPackageDealTilesInput = {
  event: 'select_promotion_bundle' | 'view_promotion_bundle'
  listings: DealDataMappedType[]
}

const buildGA4ObjectForPackageDealTiles = ({
  event,
  listings
}: BuildGA4ObjectForPackageDealTilesInput) => ({
  event,
  attributes: {
    type: 'package',
    page_name: 'homepage',
    product_name: 'bundle',
    promotion_id: 'deal_tile',
    promotion_name: `${GA4Product.STAY}_${GA4Product.FLY}`,
    location_id: 'carousel',
    ecommerce: {
      items: listings.map(listing => {
        return {
          item_id: listing.id,
          item_name: listing.cityName,
          index: listing.idx,
          price: listing.priceAmount,
          promotion_id: 'deal_tile',
          promotion_name: `${GA4Product.STAY}_${GA4Product.FLY}`
        }
      })
    }
  }
})

export default buildGA4ObjectForPackageDealTiles
